import { HttpMethods, APIContexts } from 'enums';
import { apiRequestHandler, apiHost } from '.';

const apiContext = `${APIContexts.PROGRAMLIBRARY}/`;

export const GetAssetVersionsAPI = ({
  assetId,
  excludeDoNotUse,
  onSuccess,
  ...rest
}) => {
  const api = 'GetAssetVersions';
  let endpoint = `${apiHost}${apiContext}${api}/${assetId}`;

  // Only add the query param if it's defined
  if (excludeDoNotUse !== undefined) {
    endpoint += `?excludeDoNotUse=${excludeDoNotUse}`;
  }

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetAssetSegmentsByVersionIdAPI = ({
  assetId,
  versionId,
  useTemplate = false,
  ...rest
}) => {
  const api = `GetAssetSegments`;
  const endpoint = `${apiHost}${apiContext}${api}/${assetId}?versionId=${versionId}&useTemplate=${useTemplate}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetAssetWithVersionsByExternalIdAPI = ({
  externalId,
  channelId,
  ...rest
}) => {
  const api = `/versions`;
  const endpoint = `${apiHost}${apiContext}${externalId}${api}?channelId=${channelId}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetAvailableVersionsAPI = ({ assetId, ...rest }) => {
  const api = `available-versions`;
  const query = assetId ? `?assetId=${assetId}` : '';
  const endpoint = `${apiHost}${apiContext}${api}${query}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};
